import { PAYMENT, SMS } from 'src/constants';

export const getLabelFromSectionType = (sectionType: string): string => {
  switch (sectionType) {
    case SMS:
      return 'Nombre de SMS';

    case PAYMENT:
      return 'Nombre de paiement';

    default:
      return 'Nombre de commandes';
  }
};
